<template>
  <div class="register" style="position: relative; height: 100%">
    <a @click="$router.go(-1)" class="cursor-pointer" title="Go back">
      <v-icon large>arrow_back</v-icon>
    </a>
    <v-form ref="form">
      <v-card max-width="500" class="mx-auto">
        <v-app-bar dark color="primary">
          <v-toolbar-title v-translate> Verification </v-toolbar-title>
        </v-app-bar>
        <p class="pl-6 caption ma-0 pt-4 grey--text text--darken-2">
          The verification code has been sent to your email address. If you didn't receive it, check
          the Spam folder.
        </p>
        <div class="pl-3"><ErrorMessages :error="error" /></div>
        <v-container class="pt-1 px-6 pb-0" fluid grid-list-md>
          <v-row no-gutters="">
            <v-col cols="12" class="pa-1">
              <v-text-field
                v-model="code"
                :label="$gettext('Code') + '*'"
                required
                :rules="[
                  (v) => !!v || 'This field is required',
                  (v) => v && v.length === 6 || 'The code must be 6 characters long',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pa-1">
              <v-text-field
                v-model="email"
                :label="$gettext('Email') + '*'"
                required
                :rules="[
                  (v) => !!v || 'This field is required',
                  (v) => $store.state.regexps.email.test(v) || 'This is not valid email',
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="pb-6 pr-6">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <translate> RESEND </translate>
              </v-btn>
              &nbsp; &nbsp;
            </template>

            <v-card>
              <v-form ref="formResend">
                <v-card-title class="headline grey lighten-2" primary-title>
                  Privacy Policy
                </v-card-title>
                <p class="py-2 accent--text">
                  {{ resendError }}
                </p>
                <v-card-text>
                  <v-layout class="mt-3">
                    <v-flex sm12>
                      <v-text-field
                        v-model="resendEmail"
                        :label="$gettext('Email') + '*'"
                        required
                        :rules="[
                          (v) => !!v || 'This field is required',
                          (v) => $store.state.regexps.email.test(v) || 'This is not valid email',
                        ]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" text @click="dialog = false"> Cancel </v-btn>
                  <v-btn color="primary" @click="resend"> Resend </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-btn @click="submit" color="primary">
            <translate> Submit </translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  name: 'Verification',

  data: () => ({
    code: '',
    email: '',
    error: '',
    resendEmail: '',
    resendError: '',
    dialog: false,
  }),

  created() {
    this.code = this.$route.query.code
    this.email = this.$route.query.email ? decodeURI(this.$route.query.email) : null;
  },

  methods: {
    async submit() {
      this.error = ''

      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await Auth.confirmSignUp(this.email, this.code)
          this.$router.push({ name: 'login' })
          this.loading = false
        } catch (err) {
          this.error = err.message
          this.loading = false
        }
      }
    },
    resend() {
      if (!this.$refs.formResend.validate()) return
      this.$store.commit('spinner', true)
      this.resendError = ''
      Auth.resendSignUp(this.resendEmail)
        .then(() => {
          this.$store.commit('spinner', false)
          this.$store.commit('openSnackBar', {
            text: 'The code has been successfully resent',
            color: 'success',
          })
          this.dialog = false
        })
        .catch((e) => {
          this.$store.commit('spinner', false)
          this.resendError = e.message
          console.error(e)
        })
    },
  },
}
</script>

<style scoped>
.register {
  padding: 20px;
}
::v-deep .v-text-field {
  padding-top: 0 !important;
}
</style>
